import type {
    DatapointOptions,
    CustomDataMap,
    InternalDatapointOptions,
} from 'owa-analytics-types';
import type { AnalyticsCoreEventNames } from 'owa-analytics-events';
import GreyErrorDatapoint from '../datapoints/GreyErrorDatapoint';
import { logDatapoint } from './logDatapoint';
import type { MailboxInfo } from 'owa-client-types';

export function logCoreGreyError(
    eventName: AnalyticsCoreEventNames,
    mailbox: MailboxInfo | undefined,
    error?: Error,
    customData?: CustomDataMap,
    options?: DatapointOptions
): Promise<void> {
    const logGreyErrorOptions: InternalDatapointOptions = { ...(options ? options : {}) };
    logGreyErrorOptions.isCore = true;

    return logDatapoint(
        new GreyErrorDatapoint(eventName, mailbox, error, customData, logGreyErrorOptions)
    );
}
